module.exports = __webpack_public_path__ + "static/media/hexagon.2bb7b6f0.svg";